/**
 * 用户中心：我的评论（帖子回复列表）
 */
import request, { MethodEnum, serverTriggerUrl } from "@/utils/fetch";

export interface IUserReplyItem {
  pid: number;
  tid: number;
  content: string;
  dateline: number;
  invisible?: number;
  parentId?: number;
  thread_title?: string;
  threadAuthor?: string;
  threadAuthorId?: number;
  author?: any;
  quote?: any;
}

export interface IUserRepliesListRes {
  items: IUserReplyItem[];
  total_items: number;
  pageSize?: number;
}

export interface IUserRepliesListReq {
  uid: number;
  page?: number;
  pageSize?: number;
}

export interface IReplyRedirectStatusRes {
  can_redirect: boolean;
  message?: string;
}

/**
 * GET /forum/thread/user/posts/{uid}?page=1&pagesize=20
 */
export const getUserRepliesList = (
  params: IUserRepliesListReq,
  isServerTrigger = false
): Promise<IUserRepliesListRes> => {
  const prefix = isServerTrigger ? serverTriggerUrl : '';
  return request({
    url: `${prefix}/forum/thread/user/posts/${params?.uid}`,
    method: MethodEnum.GET,
    params: params,
  }).then((data: any) => {
    return {
      ...data
    };
  });
};

/**
 * GET /forum/thread/reply/{pid}/check-status
 */
export const checkReplyRedirectStatus = (pid: number): Promise<IReplyRedirectStatusRes> => {
  return request({
    url: `/forum/thread/reply/${pid}/check-status`,
    method: MethodEnum.GET,
  }).then((data: any) => {
    return data?.item ?? data ?? {};
  });
};